<div class="relative">
  <div *ngIf="isNeedScroll&&!isAtStart" class="scroll-wrap scroll-left bg-transparent mobile:hidden"
    (mousedown)="scrollLeft()" (mouseup)="clearTimeMousemoveInterval()">
    <div></div>
  </div>
  <div class="w-[calc(100%-30px)] mobile:w-full mobile:pl-0" [class.pl-8]="!isAtStart">
    <div #timewrap class="small-time-wrap mobile:!overflow-auto mobile:pb-2" h-scroll (onScroll)="scrolling($event)">
      <div *ngFor="let time of event?.eventTimes">
        <div>
          <div class="font-semibold text-left text-gray-600">{{time.timeTwoLines.date}}</div>
          <div class="text-[13px] text-left">{{time.timeTwoLines.time}}</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isNeedScroll&&!isAtEnd" matTooltip="Hold down the mouse to scroll"
    class="scroll-wrap scroll-right bg-transparent mobile:hidden" (mousedown)="scrollRight()"
    (mouseup)="clearTimeMousemoveInterval()">
    <div></div>
  </div>

  <div *ngIf="isNeedScroll" fake-scrollbar class="w-full h-6 bg-white absolute -bottom-[7px] desktop:hidden">
    <div class="w-full h-2 mt-2 bg-gray-100 rounded-md">
      <div #fakeScrollBar class="h-full bg-gray-300 rounded-md relative" [ngStyle]="{'width':scrollBarWidth+'px'}">
      </div>
    </div>
  </div>
</div>